export var PaymentProviderType;
(function (PaymentProviderType) {
    PaymentProviderType["PINCH"] = "pinch";
    PaymentProviderType["RPS"] = "rps";
    PaymentProviderType["CUSTOM"] = "custom";
})(PaymentProviderType || (PaymentProviderType = {}));
export const paymentProviderConfig = {
    [PaymentProviderType.PINCH]: {
        enabledAccountingSystems: [`XERO`, `QBO`],
    },
    [PaymentProviderType.RPS]: {
        enabledAccountingSystems: [`XERO`, `QBO`],
    },
    [PaymentProviderType.CUSTOM]: {
        enabledAccountingSystems: [`XERO`, `QBO`],
    },
};
//# sourceMappingURL=paymentProviders.js.map